"use client";

import dynamic from "next/dynamic";

export const BlockAccordionCarouselWrapper = dynamic(() =>
  import("./BlockAccordionCarouselClient").then(mod => mod.BlockAccordionCarouselClient),
);
